class AppBase {
  constructor() {
    if (window.location.origin === 'https://applicantportal-stage.webflow.io') {
      window.grapp.environment = 'staging';
    } else if (window.location.origin === 'http://127.0.0.1:5002') {
      window.grapp.environment = 'development';
    } else {
      window.grapp.environment = 'production';
    }
    // window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  static init() {
    return new AppBase();
  }
}

AppBase.init();
